import { useEffect } from 'react';
import { PageContainer, Tile } from 'components/Layout/PageContainer';
import { useInfoDrawer } from 'context/InfoDrawerContext';
import { CountryChannelBreakdownInfoContent } from './CountryChannelBreakdownInfoContent';
import { CountryChannelBreakdownTable } from 'pages/insights-pro/country-tab/reports/country-channel-breakdown/CountryChannelBreakdownTable';

export function CountryChannelBreakdown() {
  const { setContent } = useInfoDrawer();

  useEffect(() => {
    setContent({
      titleKey: 'insights.country.reports.channel_breakdown',
      subtitleKey: 'info.content.all_dates_utc',
      content: <CountryChannelBreakdownInfoContent />,
    });

    return () => {
      setContent(null);
    };
  }, [setContent]);

  return (
    <PageContainer>
      <Tile className="text-lg p-4" titleId="insights.country.reports.channel_breakdown" />
      <CountryChannelBreakdownTable />
    </PageContainer>
  );
}
